var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollections = function SvgCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.735 8.829-1.99 2.24a2 2 0 0 1-2.99 0l-1.991-2.24a2 2 0 0 1 0-2.658l1.99-2.24a2 2 0 0 1 2.99 0l1.99 2.24a2 2 0 0 1 0 2.658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 4.219.255-.287a2 2 0 0 1 2.99 0l1.99 2.24a2 2 0 0 1 0 2.657l-1.99 2.24a2 2 0 0 1-2.99 0l-.256-.288"
  }))));
};
export default SvgCollections;